import { ApplicationName } from '@models/context/application-name';
import { Product } from '@models/context/product';

export const environment = {
  production: true,
  realProduction: false,
  prodDatabase: true,
  keycloak: {
    issuer: 'https://id.preprod.myroad.unif.app/realms/humanroads',
    clientId: 'gps-preprod',
    adminClientId: 'backoffice-preprod',
    showDebugInformation: false
  },
  analyticsEnvironment: 'preprod',
  adventureUri: '/apis/adventure',
  poiUri: '/apis/poi',
  hostSuffix: {
    [Product.Explore]: 'explore.preprod.myroad.unif.app',
    [Product.Connect]: 'connect.preprod.myroad.unif.app',
    [ApplicationName.MyRoad]: 'parcoursup.explore.preprod.myroad.unif.app',
    [ApplicationName.Oraccle]: 'oraccle.explore.preprod.myroad.unif.app',
    [ApplicationName.CmqBtpNumerique]: 'cmq-btp-numerique.explore.preprod.myroad.unif.app',
    [Product.Show]: 'salon.preprod.myroad.unif.app',
    [ApplicationName.RegionSud]: 'region-sud.explore.preprod.myroad.unif.app'
  },
  protocol: 'https://'
};
